import React, { useEffect, useState } from 'react';
import Form from 'react-bootstrap/Form';
import { Card, Col, Row } from 'react-bootstrap';
import { Link, useNavigate, useParams } from 'react-router-dom';
import axios from 'axios';
import { BASE_URL } from '../../../services/Api';
import { authHeader } from '../../../services/auth-header';

import POTOPPSIConvert from '../PumpSpareInternational/Convert';
import GRNTOPMDConvert from '../AraiManufacturing/Convert'; 

// MRN TO PURCHASE
function POTOPConvert() {
  const navigate = useNavigate();
  const { pointindex, id } = useParams();
  const [potype, setpotype] = useState('');
  const [pocategory, setpocategory] = useState('');

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await axios.get(`${BASE_URL}materialReceiptNote/findById/${id}`, {
          headers: authHeader(),
        });
        setpotype(response.data.mrntype);
        setpocategory(response.data.mrncategory);
      } catch (error) {
        console.error('Error fetching data:', error);
      }
    };
    fetchData();
  }, [id]);

  const renderPageDisplay = () => {
    if (potype === 'Pump Spare' && pocategory === 'International') {
      return <POTOPPSIConvert />;
    } else if (potype === 'Manufacturing' && pocategory === 'Domestic') {
      return <GRNTOPMDConvert />; 
    }
    return null;
  };

  return (
    <div className="Container">
      <Card className="card">
        <Card.Header className="card-header">
          <h6>CONVERT MRN TO PURCHASE</h6>
          <div className="view-buttons">
            <Link to={`/mrnindex/1`}>
              <button className="button-70">BACK</button>
            </Link>
          </div>
        </Card.Header>
        <Card.Body>
          <Row>
            <Col md="6">
              <Form.Group>
                <Form.Label>Select a Product Type:</Form.Label>
                <Form.Select disabled value={potype}>
                  <option value="">--Please choose an option--</option>
                  <option value="Pump Spare">Pump Spare</option>
                  <option value="Manufacturing">Manufacturing</option>
                </Form.Select>
              </Form.Group>
            </Col>
            <Col md="6">
              <Form.Group>
                <Form.Label>Select a PO Category:</Form.Label>
                <Form.Select disabled value={pocategory}>
                  <option value="">--Please choose an option--</option>
                  <option value="Domestic">Domestic</option>
                  <option value="International">International</option>
                </Form.Select>
              </Form.Group>
            </Col>
            {renderPageDisplay()}
          </Row>
        </Card.Body>
      </Card>
    </div>   
  );
}

export default POTOPConvert;

